import i18n from 'i18n'
import { MARKET_ROUND_PLAYER_STATES } from 'constants/marketRound'

import { loadUserTeam, payCeoAndChangeQ } from 'store/user/team'
import { loadUserBank, updateTradeReceivables } from 'store/user/bank'
import { deployMarket, loadMarketStrategy } from 'store/marketStrategy'
import { deploySalesEmployees, payFixedSalesCosts, loadSalesStrategy } from 'store/salesStrategy'
import { deployRdEmployees, loadProductQualityStrategy } from 'store/productQualityStrategy'
import { deployTrainingPoints, loadTrainingIndex } from 'store/trainingIndex'
import { loadMarketingBoard, checkMarkets } from 'store/marketingBoard'
import { changeTurn, loadUserGame } from 'store/user/game'
import { joinMarketRound, ordersSelected, loadMarketRound } from 'store/marketRound'
import { loadProductDevelopment, sendProductDevelopment } from 'store/productDevelopment'
import { buyRawMaterials, loadRequestedRawMaterials } from 'store/procurement'
import { receiveRawMaterials, loadRawMaterialsInventory } from 'store/rawMaterialsInventory'
import { applyNewLoans, payShortInterests, payLongInterests, loadLoans } from 'store/loans'
import {
  updateProduction,
  finishInvestment,
  calculateMachineryDepreciation,
  payMaintenanceCosts,
  payRentAndStorageCosts,
  idleMachines,
  loadProduction
} from 'store/production'
import { ordersToDeliver, payDeliveryPenalty } from 'store/orders'
import { payEmployeesSalaries } from 'store/employees'
import {
  calculateTaxes,
  loadIncomeStatements,
  waitCalculateBalanceSheet
} from 'store/incomeStatements'
import { calculateBalanceSheet, extractDividends, loadBalanceSheet, wait } from 'store/balanceSheet'
import { joinGraphics, finishGraphics } from 'store/graphics'

export const FINISHED_GAME = 'finished_game'
export const WINNER = 'winner'
export const GAME_OVER = 'game_over'

export const GENERAL_STATES_LIST = {
  beginning_of_the_year: 'beginning_of_the_year',
  market_round: 'market_round',
  q1: 'q1',
  q2: 'q2',
  q3: 'q3',
  q4: 'q4',
  end_of_the_year: 'end_of_the_year'
}

export const ACTIONS_STATES_LIST = {
  // Beginning of the year
  waiting_develop_market: 'waiting_develop_market',
  waiting_deploy_sales_employees: 'waiting_deploy_sales_employees',
  waiting_pay_fixed_sales_cost: 'waiting_pay_fixed_sales_cost',
  waiting_update_product_quality: 'waiting_update_product_quality',
  waiting_train_personnel: 'waiting_train_personnel',
  waiting_pay_marketing_costs: 'waiting_pay_marketing_costs',
  waiting_go_to_market_round: 'waiting_go_to_market_round',
  // Market Round
  waiting_join_market_round: 'waiting_join_market_round',
  joined_market_round: 'joined_market_round',
  market_round_finished: 'market_round_finished',
  // Quarterly Actions
  waiting_update_trade_receivables: 'waiting_update_trade_receivables',
  waiting_pay_short_term_loan_interests: 'waiting_pay_short_term_loan_interests',
  waiting_apply_new_short_term_loans: 'waiting_apply_new_short_term_loans',
  waiting_product_development: 'waiting_product_development',
  waiting_receive_raw_materials: 'waiting_receive_raw_materials',
  waiting_order_raw_material: 'waiting_order_raw_material',
  waiting_update_production: 'waiting_update_production',
  waiting_make_investments: 'waiting_make_investments',
  waiting_start_new_production: 'waiting_start_new_production',
  waiting_deliver_orders: 'waiting_deliver_orders',
  waiting_pay_ceo_salary: 'waiting_pay_ceo_salary',
  // End of the year
  waiting_pay_long_term_loan_interests: 'waiting_pay_long_term_loan_interests',
  waiting_apply_new_long_term_loans: 'waiting_apply_new_long_term_loans',
  waiting_pay_employees_salaries: 'waiting_pay_employees_salaries',
  waiting_pay_machine_maintenance: 'waiting_pay_machine_maintenance',
  waiting_pay_rent_and_storage: 'waiting_pay_rent_and_storage',
  waiting_calculate_depreciation: 'waiting_calculate_depreciation',
  waiting_pay_penalty: 'waiting_pay_penalty',
  waiting_calculate_income_statement: 'waiting_calculate_income_statement',
  waiting_income_statement_calculated: 'waiting_income_statement_calculated',
  waiting_calculate_balance_sheet: 'waiting_calculate_balance_sheet',
  waiting_balance_sheet_calculated: 'waiting_balance_sheet_calculated',
  waiting_extract_dividends: 'waiting_extract_dividends',
  waiting_annual_evaluation: 'waiting_annual_evaluation',
  waiting_join_graphics: 'waiting_join_graphics',
  joined_graphics: 'joined_graphics',
  finished_graphics: 'finished_graphics'
}

export const FINANCES_ACTIONS = [
  ACTIONS_STATES_LIST.waiting_update_trade_receivables,
  ACTIONS_STATES_LIST.waiting_pay_short_term_loan_interests,
  ACTIONS_STATES_LIST.waiting_apply_new_short_term_loans,
  ACTIONS_STATES_LIST.waiting_pay_long_term_loan_interests,
  ACTIONS_STATES_LIST.waiting_apply_new_long_term_loans
]

export const ACTIONS_STATES = [
  {
    key: ACTIONS_STATES_LIST.waiting_develop_market,
    action: deployMarket,
    reloadKey: 'marketStrategy.deployMarketSuccess',
    loadingKey: 'marketStrategy.deployMarketLoading',
    name: ACTIONS_STATES_LIST.waiting_develop_market,
    next: ACTIONS_STATES_LIST.waiting_develop_market,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: [
      ACTIONS_STATES_LIST.waiting_deploy_sales_employees,
      ACTIONS_STATES_LIST.waiting_pay_marketing_costs
    ]
  },
  {
    key: ACTIONS_STATES_LIST.waiting_deploy_sales_employees,
    action: deploySalesEmployees,
    reloadKey: 'salesStrategy.deploySuccess',
    loadingKey: 'salesStrategy.deployloading',
    name: ACTIONS_STATES_LIST.waiting_deploy_sales_employees,
    next: ACTIONS_STATES_LIST.waiting_deploy_sales_employees,
    dialog: true,
    overlay: true,
    syncActions: [
      loadUserTeam,
      loadUserBank,
      loadMarketStrategy,
      loadSalesStrategy,
      loadMarketingBoard
    ],
    sideEffectsActions: [ACTIONS_STATES_LIST.waiting_pay_marketing_costs]
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_fixed_sales_cost,
    action: payFixedSalesCosts,
    actionText: i18n.t('actions.pay'),
    reloadKey: 'salesStrategy.payCostsSuccess',
    loadingKey: 'salesStrategy.payCostsLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_fixed_sales_cost,
    next: ACTIONS_STATES_LIST.waiting_pay_fixed_sales_cost,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadSalesStrategy, loadMarketingBoard],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_update_product_quality,
    action: deployRdEmployees,
    reloadKey: 'productQualityStrategy.deploySuccess',
    loadingKey: 'productQualityStrategy.deployLoading',
    name: ACTIONS_STATES_LIST.waiting_update_product_quality,
    next: ACTIONS_STATES_LIST.waiting_update_product_quality,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_train_personnel,
    action: deployTrainingPoints,
    reloadKey: 'trainingIndex.deploySuccess',
    loadingKey: 'trainingIndex.deployLoading',
    name: ACTIONS_STATES_LIST.waiting_train_personnel,
    next: ACTIONS_STATES_LIST.waiting_train_personnel,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadProductQualityStrategy, loadMarketingBoard],
    sideEffectsActions: [ACTIONS_STATES_LIST.waiting_update_product_quality]
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_marketing_costs,
    action: checkMarkets,
    reloadKey: 'marketingBoard.payCostsSuccess',
    loadingKey: 'marketingBoard.payCostsLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_marketing_costs,
    next: ACTIONS_STATES_LIST.waiting_pay_marketing_costs,
    dialog: true,
    overlay: true,
    syncActions: [
      loadUserTeam,
      loadUserBank,
      loadProductQualityStrategy,
      loadTrainingIndex,
      loadMarketingBoard,
      loadProduction
    ],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_go_to_market_round,
    action: changeTurn,
    reloadKey: 'user.game.changeTurnSuccess',
    loadingKey: 'user.game.changeTurnLoading',
    name: ACTIONS_STATES_LIST.waiting_go_to_market_round,
    next: ACTIONS_STATES_LIST.waiting_go_to_market_round,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadMarketingBoard],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_join_market_round,
    action: joinMarketRound,
    actionText: i18n.t('actions.join'),
    reloadKey: 'marketRound.joinSuccess',
    loadingKey: 'marketRound.joinLoading',
    name: ACTIONS_STATES_LIST.waiting_join_market_round,
    next: ACTIONS_STATES_LIST.waiting_join_market_round,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    // Market round: only for sync actions
    key: ACTIONS_STATES_LIST.joined_market_round,
    syncActions: [loadMarketRound, loadUserTeam],
    sideEffectsActions: []
  },
  {
    // Market round waiting (it's not my turn)
    key: `${ACTIONS_STATES_LIST.joined_market_round}_${MARKET_ROUND_PLAYER_STATES.waiting}`,
    action: null,
    reloadKey: null,
    loadingKey: '',
    name: `${ACTIONS_STATES_LIST.joined_market_round}_${MARKET_ROUND_PLAYER_STATES.waiting}`,
    next: `${ACTIONS_STATES_LIST.joined_market_round}_${MARKET_ROUND_PLAYER_STATES.waiting}`,
    dialog: true,
    overlay: false,
    disabled: true,
    sideEffectsActions: []
  },
  {
    // Market round playing (it's my turn)
    key: `${ACTIONS_STATES_LIST.joined_market_round}_${MARKET_ROUND_PLAYER_STATES.playing}`,
    action: ordersSelected,
    reloadKey: 'marketRound.selectOrdersSuccess',
    loadingKey: 'marketRound.selectOrdersloading',
    name: `${ACTIONS_STATES_LIST.joined_market_round}_${MARKET_ROUND_PLAYER_STATES.playing}`,
    next: `${ACTIONS_STATES_LIST.joined_market_round}_${MARKET_ROUND_PLAYER_STATES.playing}`,
    dialog: true,
    overlay: false,
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.market_round_finished,
    action: changeTurn,
    reloadKey: 'user.game.changeTurnSuccess',
    loadingKey: 'user.game.changeTurnLoading',
    name: ACTIONS_STATES_LIST.market_round_finished,
    next: ACTIONS_STATES_LIST.market_round_finished,
    dialog: true,
    overlay: true,
    syncActions: [loadMarketRound, loadUserTeam],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_update_trade_receivables,
    action: updateTradeReceivables,
    reloadKey: 'user.bank.updateSuccess',
    loadingKey: 'user.bank.updateLoading',
    name: ACTIONS_STATES_LIST.waiting_update_trade_receivables,
    next: ACTIONS_STATES_LIST.waiting_update_trade_receivables,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_short_term_loan_interests,
    action: payShortInterests,
    reloadKey: 'loans.shortInterestPaymentSuccess',
    loadingKey: 'loans.shortInterestPaymentloading',
    name: ACTIONS_STATES_LIST.waiting_pay_short_term_loan_interests,
    next: ACTIONS_STATES_LIST.waiting_pay_short_term_loan_interests,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_apply_new_short_term_loans,
    action: applyNewLoans,
    reloadKey: 'loans.loanApplicationSuccess',
    loadingKey: 'loans.loanApplicationloading',
    name: ACTIONS_STATES_LIST.waiting_apply_new_short_term_loans,
    next: ACTIONS_STATES_LIST.waiting_apply_new_short_term_loans,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadLoans],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_product_development,
    action: sendProductDevelopment,
    reloadKey: 'productDevelopment.sendProductDevelopmentSuccess',
    loadingKey: 'productDevelopment.sendProductDevelopmentLoading',
    name: ACTIONS_STATES_LIST.waiting_product_development,
    next: ACTIONS_STATES_LIST.waiting_product_development,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadLoans],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_receive_raw_materials,
    action: receiveRawMaterials,
    reloadKey: 'rawMaterialsInventory.receiveOrdersSuccess',
    loadingKey: 'rawMaterialsInventory.receiveOrdersLoading',
    name: ACTIONS_STATES_LIST.waiting_receive_raw_materials,
    next: ACTIONS_STATES_LIST.waiting_receive_raw_materials,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadRawMaterialsInventory],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_order_raw_material,
    action: buyRawMaterials,
    reloadKey: 'procurement.buySuccess',
    loadingKey: 'procurement.buyLoading',
    name: ACTIONS_STATES_LIST.waiting_order_raw_material,
    next: ACTIONS_STATES_LIST.waiting_order_raw_material,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadRawMaterialsInventory, loadProductDevelopment, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_update_production,
    action: updateProduction,
    reloadKey: 'production.updateSuccess',
    loadingKey: 'production.updateLoading',
    name: ACTIONS_STATES_LIST.waiting_update_production,
    next: ACTIONS_STATES_LIST.waiting_update_production,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadRequestedRawMaterials],
    sideEffectsActions: [] // Incluir store de productos finalizados
  },
  {
    key: ACTIONS_STATES_LIST.waiting_make_investments,
    action: finishInvestment,
    reloadKey: 'production.finishSuccess',
    loadingKey: 'production.investmentLoading',
    name: ACTIONS_STATES_LIST.waiting_make_investments,
    next: ACTIONS_STATES_LIST.waiting_make_investments,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadProduction, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_start_new_production,
    action: idleMachines,
    reloadKey: 'production.startNewProductionSuccess',
    loadingKey: 'production.startNewProductionLoading',
    name: ACTIONS_STATES_LIST.waiting_start_new_production,
    next: ACTIONS_STATES_LIST.waiting_start_new_production,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadProduction, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_deliver_orders,
    action: ordersToDeliver,
    reloadKey: 'orders.deliveryOrdersSuccess',
    loadingKey: 'orders.deliveryOrdersLoading',
    name: ACTIONS_STATES_LIST.waiting_deliver_orders,
    next: ACTIONS_STATES_LIST.waiting_deliver_orders,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadProduction, loadUserBank],
    sideEffectsActions: []
  },
  // Change quarter
  {
    key: ACTIONS_STATES_LIST.waiting_pay_ceo_salary,
    action: payCeoAndChangeQ,
    reloadKey: 'user.team.payCeoAndChangeQSuccess',
    loadingKey: 'user.team.payCeoAndChangeQLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_ceo_salary,
    next: ACTIONS_STATES_LIST.waiting_pay_ceo_salary,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  // End of the year
  {
    key: ACTIONS_STATES_LIST.waiting_pay_long_term_loan_interests,
    action: payLongInterests,
    reloadKey: 'loans.longInterestPaymentSuccess',
    loadingKey: 'loans.longInterestPaymentLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_long_term_loan_interests,
    next: ACTIONS_STATES_LIST.waiting_pay_long_term_loan_interests,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_apply_new_long_term_loans,
    action: applyNewLoans,
    reloadKey: 'loans.loanApplicationSuccess',
    loadingKey: 'loans.loanApplicationloading',
    name: ACTIONS_STATES_LIST.waiting_apply_new_long_term_loans,
    next: ACTIONS_STATES_LIST.waiting_apply_new_long_term_loans,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadLoans],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_employees_salaries,
    action: payEmployeesSalaries,
    reloadKey: 'employees.salariesPaySuccess',
    loadingKey: 'employees.salariesPayLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_employees_salaries,
    next: ACTIONS_STATES_LIST.waiting_pay_employees_salaries,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadLoans],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_machine_maintenance,
    action: payMaintenanceCosts,
    reloadKey: 'production.payMaintenanceSuccess',
    loadingKey: 'production.payMaintenanceLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_machine_maintenance,
    next: ACTIONS_STATES_LIST.waiting_pay_machine_maintenance,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_rent_and_storage,
    action: payRentAndStorageCosts,
    reloadKey: 'production.payRentAndStorageSuccess',
    loadingKey: 'production.payRentAndStorageLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_rent_and_storage,
    next: ACTIONS_STATES_LIST.waiting_pay_rent_and_storage,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_calculate_depreciation,
    action: calculateMachineryDepreciation,
    reloadKey: 'production.calculateDepreciationSuccess',
    loadingKey: 'production.calculateDepreciationLoading',
    name: ACTIONS_STATES_LIST.waiting_calculate_depreciation,
    next: ACTIONS_STATES_LIST.waiting_calculate_depreciation,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_pay_penalty,
    action: payDeliveryPenalty,
    reloadKey: 'orders.payPenaltySuccess',
    loadingKey: 'orders.payPenaltyLoading',
    name: ACTIONS_STATES_LIST.waiting_pay_penalty,
    next: ACTIONS_STATES_LIST.waiting_pay_penalty,
    dialog: true,
    overlay: false,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_calculate_income_statement,
    action: calculateTaxes,
    reloadKey: 'incomeStatements.taxesSuccess',
    loadingKey: 'incomeStatements.loadingTaxes',
    name: ACTIONS_STATES_LIST.waiting_calculate_income_statement,
    next: ACTIONS_STATES_LIST.waiting_calculate_income_statement,
    dialog: true,
    overlay: false,
    syncActions: [loadUserTeam, loadUserBank],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_income_statement_calculated,
    action: waitCalculateBalanceSheet,
    reloadKey: 'incomeStatements.waitCalculateSuccess',
    loadingKey: 'incomeStatements.waitCalculateLoading',
    name: ACTIONS_STATES_LIST.waiting_income_statement_calculated,
    next: ACTIONS_STATES_LIST.waiting_income_statement_calculated,
    dialog: true,
    overlay: false,
    syncActions: [loadUserTeam, loadUserBank, loadIncomeStatements],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_calculate_balance_sheet,
    action: calculateBalanceSheet,
    reloadKey: 'balanceSheet.calculateSuccess',
    loadingKey: 'balanceSheet.loadingCalculate',
    name: ACTIONS_STATES_LIST.waiting_calculate_balance_sheet,
    next: ACTIONS_STATES_LIST.waiting_calculate_balance_sheet,
    dialog: true,
    overlay: false,
    syncActions: [loadUserTeam, loadUserBank, loadIncomeStatements],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_balance_sheet_calculated,
    action: wait,
    reloadKey: 'balanceSheet.waitDividendsExtractSuccess',
    loadingKey: 'balanceSheet.waitDividendsExtractLoading',
    name: ACTIONS_STATES_LIST.waiting_balance_sheet_calculated,
    next: ACTIONS_STATES_LIST.waiting_balance_sheet_calculated,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadBalanceSheet],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_extract_dividends,
    action: extractDividends,
    reloadKey: 'balanceSheet.extractDividendsSuccess',
    loadingKey: 'balanceSheet.extractDividendsLoading',
    name: ACTIONS_STATES_LIST.waiting_extract_dividends,
    next: ACTIONS_STATES_LIST.waiting_extract_dividends,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadBalanceSheet],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_annual_evaluation,
    action: joinGraphics,
    actionText: i18n.t('actions.join'),
    reloadKey: 'graphics.joinSuccess',
    loadingKey: 'graphics.loading',
    name: ACTIONS_STATES_LIST.waiting_annual_evaluation,
    next: ACTIONS_STATES_LIST.waiting_annual_evaluation,
    dialog: true,
    overlay: true,
    syncActions: [loadUserTeam, loadUserBank, loadBalanceSheet],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.waiting_join_graphics,
    action: null,
    reloadKey: 'graphics.joinSuccess',
    loadingKey: '',
    name: ACTIONS_STATES_LIST.waiting_join_graphics,
    next: ACTIONS_STATES_LIST.waiting_join_graphics,
    dialog: false,
    overlay: true,
    disabled: true,
    syncActions: [loadUserTeam, loadUserGame],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.joined_graphics,
    action: finishGraphics,
    actionText: i18n.t('actions.finish'),
    reloadKey: 'graphics.finishSuccess',
    loadingKey: '',
    name: ACTIONS_STATES_LIST.joined_graphics,
    next: ACTIONS_STATES_LIST.joined_graphics,
    dialog: false,
    overlay: false,
    disabled: true,
    syncActions: [loadUserTeam, loadUserGame],
    sideEffectsActions: []
  },
  {
    key: ACTIONS_STATES_LIST.finished_graphics,
    action: changeTurn,
    actionText: i18n.t('actions.start'),
    reloadKey: 'user.game.changeTurnSuccess',
    loadingKey: 'user.game.changeTurnLoading',
    name: ACTIONS_STATES_LIST.finished_graphics,
    next: ACTIONS_STATES_LIST.finished_graphics,
    dialog: true,
    overlay: false,
    syncActions: [loadUserTeam, loadUserGame],
    sideEffectsActions: []
  }
]
